import type { Visualizer } from './types';
import { clearBg, drawHud } from './types';

export const ringViz: Visualizer = {
  id: 'ring',
  label: 'Halo Rings',
  draw(frame) {
    const { ctx, w, h, freq, bands, t } = frame;
    clearBg(ctx, w, h, 0.4);
    const cx = w / 2;
    const cy = h / 2;
    const base = Math.min(w, h) * 0.12;
    const rings = 18;
    for (let i = 0; i < rings; i++) {
      const f = freq[Math.floor((i / rings) * freq.length)] / 255;
      const r = base + i * (Math.min(w, h) * 0.018) + f * Math.min(w, h) * 0.05 + bands.bass * 12;
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.strokeStyle = `hsla(${160 + i * 8 + t * 20}, 95%, ${50 + f * 30}%, ${0.25 + f * 0.55})`;
      ctx.lineWidth = 1.5 + f * 3 + bands.beat * 2;
      ctx.stroke();
    }
    // core
    const core = ctx.createRadialGradient(cx, cy, 2, cx, cy, base * (1.2 + bands.energy));
    core.addColorStop(0, `rgba(255,255,255,${0.55 + bands.beat * 0.3})`);
    core.addColorStop(0.35, `rgba(86,240,200,${0.35 + bands.energy * 0.3})`);
    core.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = core;
    ctx.beginPath();
    ctx.arc(cx, cy, base * 2.2, 0, Math.PI * 2);
    ctx.fill();
    drawHud(frame);
  },
};
